export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            关于耽美漫画网
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            耽美漫画网成立于对耽美文化的热爱与坚持之上，致力于为广大腐女同好打造一个干净、纯粹、完全免费的耽美漫画在线阅读空间。我们精心筛选海内外优质 BL 漫画资源，涵盖古风权谋、现代都市、校园青春、奇幻异世、仙侠修真等多元题材，每日保持高频更新节奏，让每一位读者都能在这里找到触动心弦的作品。平台始终坚持「零门槛、零付费」原则，无需注册即可畅享全部高清漫画内容，以最朴素的初心守护每一份对耽美的热爱。
          </p>
        </div>
      </div>
    </section>
  );
}